import React, { useState, useEffect } from "react";
import { MovimientosListado } from "./Movimientos/MovimientosListado";
import { MovimientosABM } from "./Movimientos/MovimientosABM";
import { cajaBancosAPI, type TipoMovimiento } from "@/lib/api";
import { toast } from "sonner";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

export function MovimientosSection() {
  const [showABM, setShowABM] = useState(false);
  const [selectedTipo, setSelectedTipo] = useState<TipoMovimiento | null>(null);
  const [tipos, setTipos] = useState<TipoMovimiento[]>([]);
  const [loading, setLoading] = useState(true);

  // Load tipos from API on mount
  useEffect(() => {
    const fetchTipos = async () => {
      try {
        const data = await cajaBancosAPI.listTiposMovimiento();
        setTipos(data);
      } catch (error) {
        console.error("Error loading tipos de movimiento:", error);
        toast.error("Error al cargar tipos de movimiento");
      } finally {
        setLoading(false);
      }
    };
    fetchTipos();
  }, []);

  const handleEdit = (tipo: TipoMovimiento) => {
    setSelectedTipo(tipo);
    setShowABM(true);
  };

  const handleNew = () => {
    setSelectedTipo(null);
    setShowABM(true);
  };

  const handleBack = () => {
    setShowABM(false);
    setSelectedTipo(null);
  };

  const handleSave = async (tipo: TipoMovimiento) => {
    try {
      if (tipo.id) {
        await cajaBancosAPI.updateTipoMovimiento(tipo.codigo, tipo);
      } else {
        await cajaBancosAPI.createTipoMovimiento(tipo);
      }
      // Refresh from API
      const updated = await cajaBancosAPI.listTiposMovimiento();
      setTipos(updated);
      handleBack();
      toast.success("Tipo de movimiento guardado");
    } catch (error) {
      console.error("Error saving tipo:", error);
      const err = error as { data?: { moneda?: string[] | string; detail?: string }; message?: string };
      const monedaErr = err?.data?.moneda;
      const msg =
        (Array.isArray(monedaErr) && monedaErr[0]) ||
        (typeof monedaErr === "string" && monedaErr) ||
        (typeof err?.data?.detail === "string" && err.data.detail) ||
        "Error al guardar tipo de movimiento";
      toast.error(msg);
    }
  };

  const handleDelete = async (codigo: string) => {
    try {
      const tipoToDelete = tipos.find(t => t.codigo === codigo);
      if (tipoToDelete?.codigo) {
        await cajaBancosAPI.deleteTipoMovimiento(tipoToDelete.codigo);
      }
      // Refresh from API
      const updated = await cajaBancosAPI.listTiposMovimiento();
      setTipos(updated);
      handleBack();
      toast.success("Tipo de movimiento eliminado");
    } catch (error) {
      console.error("Error deleting tipo:", error);
      toast.error("Error al eliminar tipo de movimiento");
    }
  };

  useRegisterOpcionesAbmNav(showABM, selectedTipo != null, handleBack);

  if (loading) {
    return <div className="p-8 text-center">Cargando tipos de movimiento...</div>;
  }

  return (
    <div className="space-y-6">
      {showABM ? (
        <MovimientosABM
          tipo={selectedTipo}
          onBack={handleBack}
          onSave={handleSave}
          onDelete={handleDelete}
        />
      ) : (
        <MovimientosListado tipos={tipos} onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}